import { GalleryImageField } from '@monoimin/sb-types';

import { pickFirstImageFromGalleryField } from './pickFirstImageFromGalleryField';

export const getGalleryImageSrc = (item: GalleryImageField) => {
  const first = pickFirstImageFromGalleryField(item);

  if (!first) {
    return '';
  }

  return first.src;
};

export default getGalleryImageSrc;
